
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const [{createUI, installThemeToggle, installHashImportBanner}, {createGameUI, finaleStarter}] = await Promise.all([import("./lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  return module;
}), import("./lib/bgio.js").then((module) => {
  if (!("createGameUI" in module)) throw new SyntaxError(`export 'createGameUI' not found`);
  if (!("finaleStarter" in module)) throw new SyntaxError(`export 'finaleStarter' not found`);
  return module;
})]);
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, canvasTestReport } = createUI({ html });
const { gameCanvas, gameCanvasTest, mountEditor, mountGameSection, sectionLabel } = createGameUI({ html });
// Das Finale zeigt ALLES in einer Datei: deine Spiellogik (TicTacToe) aus den
// vorigen Kapiteln plus die neue draw-Funktion, die das Brett zeichnet. Wenn
// deine eigene TicTacToe.js laeuft, nehmen wir die als Startpunkt -- sonst
// eine funktionierende Reserve-Version -- und haengen das draw-Geruest an.
const starter = finaleStarter();
return {createUI,installThemeToggle,installHashImportBanner,createGameUI,finaleStarter,codeEditor,canvasTestReport,gameCanvas,gameCanvasTest,mountEditor,mountGameSection,sectionLabel,starter};
},
    inputs: ["html","display"],
    outputs: ["createUI","installThemeToggle","installHashImportBanner","createGameUI","finaleStarter","codeEditor","canvasTestReport","gameCanvas","gameCanvasTest","mountEditor","mountGameSection","sectionLabel","starter"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-3`),
    expanded: [],
    variables: []
  },
  {
    id: 3,
    body: (codeEditor,starter,html,gameCanvas,canvasTestReport,gameCanvasTest,mountEditor,mountGameSection,sectionLabel) => {
const editor = codeEditor("bgio:finale", { value: starter, label: "Deine Datei: TicTacToe.js" });
const boardSlot = html`<div></div>`;
const feedbackSlot = html`<div></div>`;

const CHECKS = [
  { name: "Das 3×3-Gitter ist zu sehen", run: ({ base }) => {
      const n = base.nonBg();
      return { passed: n > 100, detail: `${n} gezeichnete Pixel` };
  } },
  { name: "Markierungen aus G.cells werden gezeichnet", run: ({ probe }) => {
      const p = probe({ cells: ["0", null, null, null, "1", null, null, null, null] });
      const a = p.cellInk(0), b = p.cellInk(4), leer = p.cellInk(1);
      return {
        passed: a > 15 && b > 15 && leer < 8,
        detail: `Zelle 0 (✕): ${a}, Zelle 4 (◯): ${b}, leere Zelle: ${leer}`
      };
  } },
  { name: "Jede Zelle ist anklickbar und löst den richtigen Zug aus", run: ({ probe }) => {
      const p = probe();
      for (let i = 0; i < 9; i++) p.clickAt((i % 3) * 100 + 50, Math.floor(i / 3) * 100 + 50);
      const got = new Set(p.moves);
      const all = [0, 1, 2, 3, 4, 5, 6, 7, 8].every(i => got.has(i));
      return {
        passed: all,
        detail: `clickCell-Aufrufe: ${[...got].sort((x, y) => x - y).join(", ") || "keine"}`
      };
  } },
  { name: "Das Spielende wird auf dem Brett angezeigt", run: ({ probe }) => {
      // Dieselbe Endstellung zweimal zeichnen: einmal ohne gameover (normales
      // Brett) und einmal mit gameover. Wer das Ergebnis anzeigt, malt im
      // zweiten Fall etwas Zusätzliches -- die Pixel unterscheiden sich dann.
      const cells = ["0", "0", "0", null, "1", null, "1", null, null];
      const ohne = probe({ cells, gameover: null });
      const mit = probe({ cells, gameover: { winner: "0" } });
      let diff = 0;
      for (let y = 0; y < 300; y += 5) {
        for (let x = 0; x < 300; x += 5) {
          const a = ohne.pixel(x, y), b = mit.pixel(x, y);
          if (Math.abs(a[0] - b[0]) + Math.abs(a[1] - b[1]) + Math.abs(a[2] - b[2]) > 40) diff++;
        }
      }
      return {
        passed: diff > 12,
        detail: diff > 12 ? `Bei gameover wird etwas Zusätzliches gezeichnet (${diff} Punkte)` : "draw zeichnet bei gameover nichts anderes — zeig Gewinner/Unentschieden an"
      };
  } }
];

function rerun() {
  const code = editor.value;
  boardSlot.replaceChildren(gameCanvas(code, {
    width: 300,
    height: 300,
    hint: "Sobald alle 9 Zellen anklickbar sind, spielst du dein Tic-Tac-Toe komplett auf deinem eigenen Spielbrett — mit deiner eigenen Spiellogik dahinter."
  }));
  feedbackSlot.replaceChildren(canvasTestReport(gameCanvasTest(code, { checks: CHECKS }), "Übung"));
}

mountEditor({ editor, title: "TicTacToe.js" });
const section = mountGameSection({
  nodes: [
    sectionLabel("Dein Spielbrett"), boardSlot,
    sectionLabel("Übung"), feedbackSlot
  ],
  onRun: () => { const b = editor.querySelector(".run-button"); if (b) b.click(); }
});
editor.addEventListener("input", () => { rerun(); section.expand(); });
rerun();
return {editor,boardSlot,feedbackSlot,CHECKS,rerun,section};
},
    inputs: ["codeEditor","starter","html","gameCanvas","canvasTestReport","gameCanvasTest","mountEditor","mountGameSection","sectionLabel"],
    outputs: ["editor","boardSlot","feedbackSlot","CHECKS","rerun","section"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
